module.exports = __webpack_public_path__ + "stylesheets/section-background-text_673293687f30a269467d630759287cc7.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-background-text.less
// module id = y+GP
// module chunks = 151